import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PortalFiles } from '../../_models/portal/interfaces';
import { PortalManagementFilesService } from 'src/app/features/portal/_services/management/portal-management-files.service';

@Component({
  selector: 'share-user-files',
  templateUrl: './share-user-files.component.html',
  styleUrls: ['./share-user-files.component.scss']
})
export class ShareUserFilesComponent implements OnInit {
  @Input() files: PortalFiles[] | undefined;
  @Input() showUploadButton: boolean = false;
  @Output() uploadRequested = new EventEmitter<void>();
  @Output() downloadRequested = new EventEmitter<{ file_id: string; fileName: string }>();

  constructor(private pmfs: PortalManagementFilesService) {}

  ngOnInit(): void {}

  downloadFile(file_id: string, fileName: string) {
    // Emit download event to parent component
    this.downloadRequested.emit({ file_id, fileName });
  }

  onUploadClick() {
    this.uploadRequested.emit();
  }
}
